import type { BFFArticleBodyElement } from "@src/app/types/bff";

export default function ArticleHorizonRow({
  element,
}: {
  element: BFFArticleBodyElement["horizontal_row"];
}) {
  console.log(element, "element");
  return (
    <div className="py-4">
      <div className="h-px bg-divider-primary" />
    </div>
  );
}
